export const SET_COOKIES = 'SET_COOKIES';
export const REMOVE_ORDER_COOKIES = 'REMOVE_ORDER_COOKIES';
export const ANALYTICS_SESSION_COOKIE_KEY = '__campaign_session_cookie__';
export const ANALYTICS_SESSION_TRIGGERED = 'session__triggered';
export const ANALYTICS_TRIGGERED_PATHNAME = 'triggered__pathname';
export const ANALYTICS_DEFAULT_TRAITS = 'default_traits';
export const GROVER_NATIVE_FLOW = 'nativeFlowActive';
